(function () {
  function frameSrc(baseUrl, i) {
    if (!baseUrl) return '';
    if (baseUrl.indexOf('v360_DS_') !== -1) {
      var prefix = /_$/.test(baseUrl) ? baseUrl : baseUrl + '_';
      return prefix + String(i).padStart(5, '0') + '.webp';
    }
    if (baseUrl.indexOf('v360_Carla-Ecushion-cut') !== -1) {
      return baseUrl + String(i).padStart(3, '0') + '.webp';
    }
    return baseUrl.replace(/\/?$/, '/') + i + '.webp';
  }

  function createViewer(container, baseUrl, frameCount, topImg) {
    var images = [];
    var currentFrame = 0;
    var isPlaying = false;
    var isDragging = false;
    var startX = 0;
    var imagesLoaded = 0;
    var animationFrameId = null;
    var isActive = true;
    var currentVisibleImg = null;
    var lastTime = 0;
    var directionFactor = 1;
    var rotationFps = 24;
    var rotationSpeed = 2;
    var count = parseInt(frameCount, 10) || 0;

    if (container.viewer && container.viewer.destroy) container.viewer.destroy();

    var imageContainer = container.querySelector('.main-360-viewer');
    if (!imageContainer) {
      imageContainer = document.createElement('div');
      imageContainer.className = 'main-360-viewer';
      container.appendChild(imageContainer);
    }
    imageContainer.innerHTML = '';

    var loadingDiv = container.querySelector('.viewer-loading');
    if (!loadingDiv) {
      loadingDiv = document.createElement('div');
      loadingDiv.className = 'viewer-loading';
      loadingDiv.innerHTML = `
        <div>
          <img loading="eager" src="${topImg || ''}" alt="">
          <span style="${baseUrl.indexOf('http') !== -1 ? 'display:block;' : 'display:none;'}">
            Loading 360° View...
          </span>
        </div>`;
      container.appendChild(loadingDiv);
    }

    function cancelAnim() {
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
        animationFrameId = null;
      }
    }

    function destroy() {
      isActive = false;
      isPlaying = false;
      cancelAnim();
      container.removeEventListener('pointerdown', onPointerDown);
      container.removeEventListener('pointermove', onPointerMove);
      container.removeEventListener('pointerup', onPointerUp);
      container.removeEventListener('pointercancel', onPointerUp);
    }

    function animate() {
      if (!container.isConnected) {
        destroy();
        return;
      }
      if (!isPlaying || isDragging || !isActive || !container.classList.contains('active')) {
        isPlaying = false;
        cancelAnim();
        lastTime = 0;
        return;
      }
      var now = performance.now();
      if (!lastTime) {
        lastTime = now;
        animationFrameId = requestAnimationFrame(animate);
        return;
      }
      var delta = (now - lastTime) / 1000;
      lastTime = now;
      currentFrame = (currentFrame + rotationFps * delta * directionFactor + count) % count;
      var imageToSet = images[Math.floor(currentFrame)];
      if (imageToSet) {
        if (currentVisibleImg && currentVisibleImg !== imageToSet) currentVisibleImg.style.visibility = 'hidden';
        imageToSet.style.visibility = 'visible';
        currentVisibleImg = imageToSet;
      }
      animationFrameId = requestAnimationFrame(animate);
    }

    function play() {
      if (!isActive) return;
      isPlaying = true;
      if (animationFrameId) return;
      lastTime = 0;
      animate();
    }

    function pause() {
      isPlaying = false;
      cancelAnim();
    }

    function showFrame(i) {
      var imageToSet = images[i];
      if (!imageToSet) return;
      if (currentVisibleImg && currentVisibleImg !== imageToSet) currentVisibleImg.style.visibility = 'hidden';
      imageToSet.style.visibility = 'visible';
      currentVisibleImg = imageToSet;
    }

    function onPointerDown(e) {
      if (imagesLoaded !== count || isDragging) return;
      isDragging = true;
      pause();
      startX = e.clientX;
      try {
        container.setPointerCapture(e.pointerId);
      } catch (err) {}
    }

    function onPointerMove(e) {
      if (!isDragging) return;
      var diff = e.clientX - startX;
      startX = e.clientX;
      var sign = Math.sign(diff);
      if (sign) directionFactor = -sign;
      currentFrame = (currentFrame - sign * rotationSpeed + count) % count;
      showFrame(Math.floor(currentFrame));
    }

    function onPointerUp() {
      if (!isDragging) return;
      isDragging = false;
      play();
    }

    for (var i = 0; i < count; i++) {
      (function (index) {
        var img = new Image();
        img.src = frameSrc(baseUrl, index);
        img.onload = function () {
          img.style.cssText =
            'position:absolute;top:0;left:0;width:100%;height:100%;object-fit:contain;visibility:hidden;pointer-events:none;';
          imageContainer.appendChild(img);
          images[index] = img;
          imagesLoaded += 1;
          if (imagesLoaded === count) {
            if (loadingDiv.parentNode) loadingDiv.remove();
            play();
          }
        };
      })(i);
    }

    container.addEventListener('pointerdown', onPointerDown);
    container.addEventListener('pointermove', onPointerMove);
    container.addEventListener('pointerup', onPointerUp);
    container.addEventListener('pointercancel', onPointerUp);

    var viewer = { destroy: destroy, play: play, pause: pause };
    container.viewer = viewer;
    return viewer;
  }

  window.syncStuds360 = function (slide) {
    var g = document.getElementById('ProductGallery');
    if (!g || !g.hasAttribute('data-studs-360')) return;
    g.querySelectorAll('.product-gallery__slide--360').forEach(function (el) {
      if (el === slide) {
        if (!el.viewer) {
          createViewer(
            el,
            el.getAttribute('data-v360-url'),
            el.getAttribute('data-frame-count'),
            el.getAttribute('data-top-img')
          );
        } else if (el.viewer.play) {
          el.viewer.play();
        }
      } else if (el.viewer && el.viewer.pause) {
        el.viewer.pause();
      }
    });
  };

  document.addEventListener(
    'touchstart',
    function (e) {
      if (e.target.closest('.product-gallery__slide--360')) e.stopPropagation();
    },
    true
  );
  document.addEventListener(
    'touchend',
    function (e) {
      if (e.target.closest('.product-gallery__slide--360')) e.stopPropagation();
    },
    true
  );
})();
